/**
 * Canonical URL param names read by Settings.tsx.
 * Use these constants instead of inline strings to avoid silent mismatch bugs.
 */
export const SETTINGS_PARAMS = {
  /** Returned from Stripe Checkout — new subscription or trial→paid upgrade */
  UPGRADED:         'upgraded',
  /** Returned from Stripe Checkout after reactivating a suspended account */
  REACTIVATED:      'reactivated',
  /** Redirected from Onboarding when Stripe checkout fails mid-wizard */
  UPGRADE:          'upgrade',
  /** Redirected from pending_payment guard — user needs to select a plan and pay */
  COMPLETE_PAYMENT: 'complete_payment',
  /** Generic deep-link to the Plan tab */
  TAB:              'tab',
} as const

/**
 * Canonical navigation paths for billing-related redirects.
 * Use these instead of inline strings in navigate() and Stripe success/cancel URLs.
 * Note: Stripe URLs must be absolute — prefix with window.location.origin.
 */
export const SETTINGS_URLS = {
  /** Open the Plan tab with no specific action */
  PLAN_TAB:          '/settings?tab=plan',
  /** Open Plan tab so a pending_payment user can select a plan and pay */
  COMPLETE_PAYMENT:  '/settings?tab=plan&complete_payment=1',
  /** Open Plan tab showing the upgrade CTA (checkout failed mid-wizard) */
  UPGRADE_INTENT:    '/settings?upgrade=1',
  /** Returned from Stripe Checkout — triggers polling + success banner */
  POST_CHECKOUT:     '/settings?upgraded=1',
  /** Returned from Stripe after reactivating a suspended account */
  POST_REACTIVATION: '/settings?tab=plan&reactivated=1',
} as const
